import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Utils from "../../utils/Utils";
import { getUserPersonas } from "../../services/AnamnesisService";
import fullLogo from "../../assets/images/svg/unicornio-brown.svg";
import { switchActivePersona } from "../../utils/personaStorage";
import "../../assets/styles/ModalFamilyProfile.css";

import kidsImg from "../../assets/images/unicornio-kids.png";
import babyImg from "../../assets/images/unicornio-baby.png";
import homemImg from "../../assets/images/unicornio-homem.png";
import mulherImg from "../../assets/images/unicornio-mulher.png";

const ModalCardPesquisa = () => {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const personas = await getUserPersonas();
        // Normaliza para [{ id, nome, tipo, img }]
        const perfis = (Array.isArray(personas) ? personas : []).map((p) => {
          const origin = String(p.origin || "").toLowerCase();
          let tipo = "adulto";
          if (/kids/.test(origin)) tipo = "kids";
          else if (/baby/.test(origin)) tipo = "baby";
          else tipo = "adulto";

          // Prioriza imagem vinda do backend; senão, aplica fallback pelo tipo/gênero
          let img = p?.image_url || p?.image || null;
          if (!img) {
            if (tipo === "kids") img = kidsImg;
            else if (tipo === "baby") img = babyImg;
            else {
              const isFemale = String(p.gender) === "2";
              img = isFemale ? mulherImg : homemImg;
            }
          }

          return {
            id: p?.per_id || p?.id,
            nome: p.name || p.display_name || "Perfil",
            tipo,
            img,
          };
        });
        setProfiles(perfis);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const dismissThenGo = (to) => (e) => {
    e.preventDefault();
    const el = document.getElementById("bootstrapModal");
    const bs = window?.bootstrap;
    if (el && bs?.Modal) {
      const inst = bs.Modal.getInstance(el) || bs.Modal.getOrCreateInstance(el);
      const onHidden = () => {
        el.removeEventListener("hidden.bs.modal", onHidden);
        navigate(to);
      };
      el.addEventListener("hidden.bs.modal", onHidden);
      inst.hide();
    } else {
      navigate(to);
    }
  };

  return (
    <div className="ModalFamilyProfile" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-lg-4">
            <img
              src={fullLogo}
              alt="Puríssima"
              style={{ maxHeight: "100px" }}
            />
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-11 text-center">
            <h3 className="my-3 my-lg-4">
              <strong>Alterar painel do cliente para:</strong>
            </h3>
            <div className="d-flex flex-wrap justify-content-center gap-4 mt-4">
              {loading ? (
                <span>Carregando perfis...</span>
              ) : profiles.length === 0 ? (
                <span>Nenhum perfil encontrado.</span>
              ) : (
                profiles.map((perfil, idx) => (
                  <button
                    key={perfil.id || idx}
                    className="family-profile-card btn p-0 border-0 bg-transparent"
                    style={{
                      width: 150,
                      background: "#fff",
                      borderRadius: 16,
                      padding: 16,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      switchActivePersona(perfil.id);

                      // Fecha o modal
                      const el = document.getElementById("bootstrapModal");
                      const bs = window?.bootstrap;
                      if (el && bs?.Modal) {
                        const inst =
                          bs.Modal.getInstance(el) ||
                          bs.Modal.getOrCreateInstance(el);
                        inst.hide();
                      }
                    }}
                  >
                    <div className="modal-avatar">
                      {perfil.img ? (
                        <img
                          src={perfil.img}
                          alt={perfil.nome}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <span style={{ color: "#bbb" }}>Sem imagem</span>
                      )}
                    </div>
                    <div
                      style={{
                        fontWeight: 700,
                        fontSize: 20,
                        color: "#7B6A58",
                        textTransform: "uppercase",
                      }}
                    >
                      {Utils.firstName(perfil.nome)}
                    </div>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#B6A892",
                        letterSpacing: 1,
                      }}
                    >
                      {perfil.tipo}
                    </div>
                  </button>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCardPesquisa;
